import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { ScanText } from 'lucide-react';
import { getApi } from '../../api/endpoints';
import { toastStore } from '../../state/toasts';
import { errorMessageKey } from '../../pages/ErrorBox';
import { aiConfigStore, loadAiConfig } from './store';

/** Query parameter read by the editor's AI import host (kept in sync with Host.tsx). */
const PARAM = 'aiimport';

/**
 * Boards page: "New board from rider" (decision U9) – creates a board and opens the editor with
 * the AI import wizard. Hidden when the AI import is not configured.
 */
export function NewBoardFromRider({ workspaceId, name }: { workspaceId: string; name: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const enabled = useStore(aiConfigStore, (s) => s.enabled);
  useEffect(() => {
    void loadAiConfig();
  }, []);
  if (!enabled) return null;
  const create = () =>
    getApi()
      .createBoard(workspaceId, { name: name.trim() || t('aiImport.newBoardName') })
      .then(
        (b) => navigate(`/b/${b.id}?${PARAM}=1`),
        (err: unknown) =>
          toastStore.getState().push({ kind: 'error', message: t(errorMessageKey(err)) }),
      );
  return (
    <button type="button" className="btn" onClick={() => void create()}>
      <ScanText size={16} aria-hidden="true" /> {t('aiImport.newBoard')}
    </button>
  );
}
